import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';

const BASE_URL = 'api/{db}/';


@Injectable()

export class AppService {

	constructor(private http: HttpClient,
				private toastr: ToastrService) {
	}

	// http get methode
	httpGet(url: string): Observable<any> {
		return this.http.get<any>(BASE_URL + url).pipe(
			catchError(
				(err) => {
					return this.handleError(err);
				}
			));
	}


	// http post methode
	httpPost(url: string, params: any, options: any = []): Observable<any> {
		return this.http.post<any>(BASE_URL + url, params,options).pipe(
			catchError(
				(err) => {
					return this.handleError(err);
				}
			)
		);
	}

	// http patch methode
	httpPatch(url: string, params: any): Observable<any> {
		return this.http.patch<any>(BASE_URL + url, params).pipe(
			catchError(
				(err) => {
					return this.handleError(err);
				}
			)
		);
	}


	// http delete methode
	httpDelete(url: string): Observable<any> {
		return this.http.delete<any>(BASE_URL + url).pipe(
			catchError(
				(err) => {
					return this.handleError(err);
				}
			)
		);
	}

	// Errors
	private handleError(erreur) {

		//this.toastr.error(erreur.message, erreur.status + ' : ' + erreur.statusText);
		return throwError(erreur);

	}
}
